import { Check, Clear } from "@mui/icons-material"
import { ListItemIcon, ListItemText, Menu, MenuItem, MenuList } from "@mui/material"
import { observer } from "mobx-react-lite"
import { useMenu } from "../../../../app/hook/useMenu"
import { HomeFilterButton } from "../../common/HomeFilterButton"
import { IHomeTableFilterSession, MinMax } from "../hook/useTable"

interface Props {
    handleChange: (column: IHomeTableFilterSession, value: string | MinMax) => void;
    handleClear: (column: IHomeTableFilterSession) => void;
    filtered: string[];
    session: IHomeTableFilterSession;
    list: string[]
}

const session = 'equipmentType'

const ObjectTypeFilter = ({ handleChange, handleClear: clearFilter, filtered, list }: Props) => {
    const { anchorEl, isOpen, handleClose, handleOpen } = useMenu()

    const handleClear = () => {
        clearFilter(session)
        handleClose()
    }
    
    return (
        <>
            <HomeFilterButton color={filtered.length > 0 ? 'success' : 'default'} onClick={handleOpen} />
            <Menu open={isOpen} onClose={handleClose} anchorEl={anchorEl}>
                <MenuList sx={{ minWidth: '200px', maxHeight: '200px' }}>
                    <MenuItem onClick={handleClear}>
                        <ListItemIcon><Clear fontSize="small" /></ListItemIcon>
                        <ListItemText>Clear</ListItemText>
                    </MenuItem>
                    {list.map((item, index) => {
                        let selected = filtered.includes(item)
                        
                        return (
                            <MenuItem 
                                key={index} 
                                onClick={() => handleChange(session, item)} 
                                selected={selected}
                            >
                                {selected && <ListItemIcon><Check fontSize="small" /></ListItemIcon>}
                                <ListItemText inset={!selected}>{item}</ListItemText>
                            </MenuItem>
                        )
                    })}
                </MenuList>
            </Menu>
        </>
    )
}

export default observer(ObjectTypeFilter)